import { getRequest } from '../../../../utils/httpRequest'
import { URL } from '../../../../config'

const reportsURL = URL.reports
const seasonURL = URL.season

export const getOilRatiosReport = function(startDate, endDate){
  const endPoint = `${reportsURL}/oilratios/${startDate}/${endDate}`
  return getRequest(endPoint)
}

export const getSeasonSettingsReport = function(season){
  const endPoint = `${reportsURL}/seasonsettings/${season}`
  return getRequest(endPoint)
}

export const getPointsByEventReport = function (season) {
  const endPoint = `${reportsURL}/pointsbyevent/${season}`
  return getRequest(endPoint)
}

export const getRankingExceptionsReport = function (startDate, endDate) {
  const endPoint = `${reportsURL}/rankingexceptions/${startDate}/${endDate}`
  return getRequest(endPoint)
}

export const getLowGameCountReport = function (startDate, endDate) {
  const endPoint = `${reportsURL}/lowgamecount/${startDate}/${endDate}`
  return getRequest(endPoint)
}

export const getSeasonsBowledReport = function (season) {
  const endPoint = `${reportsURL}/seasonsbowled/${season}`
  return getRequest(endPoint)
}

export const getSeasonDates = function(){
  const endPoint = `${seasonURL}/all`
  return getRequest(endPoint)
}

export const getEventByEventReport = function (season) {
  const endPoint = `${reportsURL}/eventbyeventavg/${season}`
  return getRequest(endPoint)
}

export const getStandingsByEventReport = function (season) {
  const endPoint = `${reportsURL}/standingsbyevent/${season}`
  return getRequest(endPoint)
}


// WEBPACK FOOTER //
// ./src/components/pages/Report/api/index.js